import React, { useState, useEffect, useCallback, useRef } from "react";
import axios from "axios";
import { APIURL } from "../../../config";
import moment from "moment-timezone";
import { TextField, Typography, Button, Box, darken, lighten, Link, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import AssignmentIcon from '@mui/icons-material/Assignment';
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV2";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import DefaultToolbar from "src/components/DataGrid/DefaultToolbar";
import { DataGridPro, ToolbarButton, useGridApiRef } from "@mui/x-data-grid-pro";
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import SaveViewButton from "../../DataGrid/SaveViewButton";
import Tooltip from "@mui/material/Tooltip";
import "./Claims.css";
import Upload from "../../Billing/Claims/Upload";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { AnalyticsBrowser } from '@segment/analytics-next'
import { SEGMENTAPIKEY } from '../../../config';
import withStyles from "@mui/styles/withStyles";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import CMSForm from "./CMSForm";


const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "#3FA7D6",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#3FA7D6",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "lightblue",
      },
      "&:hover fieldset": {
        borderColor: "#3FA7D6",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#3FA7D6",
      },
    },
  },
})(TextField);

const analytics = AnalyticsBrowser.load({ writeKey: SEGMENTAPIKEY })

const dateComparator = (v1, v2) => moment(v1).diff(moment(v2));

const dateProcCodeModifComparator = (val1, val2) => {
  if (val1.status !== 'Ready to Bill' && val2.status !== 'Ready to Bill') {
    return moment(val1.createDate).diff(moment(val2.createDate));
  }

  let mods1 = val1.procCodeModifer;
  if (typeof mods1 !== "string" || mods1 === "null") {
    mods1 = "";
  }
  mods1 = mods1.split(":");
  let mods2 = val2.procCodeModifer;
  if (typeof mods2 !== "string" || mods2 === "null") {
    mods2 = "";
  }
  mods2 = mods2.split(":");

  let t1 = (val1.errors.length !== 0 && val1.status === 'Ready to Bill') || (val1.isSubmittable && val1.status === "Ready to Bill" && !((mods1[0] === "" && mods1.length === 1 && val1.procCode.length === 5) || (mods1[0] !== "" && mods1.filter((m) => m.length === 2).length === mods1.length && val1.procCode.length === 5))) ? moment('12-31-2100', 'MM-DD-YYYY') : moment(val1.createDate);
  let t2 = (val2.errors.length !== 0 && val2.status === 'Ready to Bill') || (val2.isSubmittable && val2.status === "Ready to Bill" && !((mods2[0] === "" && mods2.length === 1 && val2.procCode.length === 5) || (mods2[0] !== "" && mods2.filter((m) => m.length === 2).length === mods2.length && val2.procCode.length === 5))) ? moment('12-31-2100', 'MM-DD-YYYY') : moment(val2.createDate);
  return t1.diff(t2);
}

const checkClaim = (field, newVal, payerList, NJMMIS = true) => {
  let mandatoryFields = [
    "DDDID",
    "FirstName",
    "LastName",
    "Gender",
    "DateOfBirth",
    "memberMedicaid",
    "priorAuth",
    "procedureCode",
    "startDate",
    "endDate",
    "DiagnosisCode",
    "authUnits",
    "authAmount",
  ];
  let numFields = ["DDDID", "memberMedicaid", "priorAuth", "authUnits"];
  let decFields = ["authAmount"];
  let dateFields = ["startDate", "endDate", "DateOfBirth"];
  let genderFields = ["Gender"];
  let fixedLengthFields = ["priorAuth"];
  let nameFields = ["FirstName", "LastName"];
  let alphanumericFields = ["procedureCode", "procedureModifierCode"];

  let lengthMap = {
    "priorAuth": 10,
  }

  if (!NJMMIS) {
    mandatoryFields.push("patientAddrLine1", "patientCity", "patientState", "patientZip");
    fixedLengthFields = []
    lengthMap = {}
  }

  let empty = false,
    notNum = false,
    notDec = false,
    invalidGender = false,
    invalidDate = false,
    invalidLength = false,
    invalidName = false,
    invalidAlphanum = false,
    earlyBillDate = false,
    invalidPayerId = false,
    invalidDiagnosisCode = false;

  if (mandatoryFields.includes(field)) {
    newVal ? (empty = false) : (empty = true);
  }
  if (numFields.includes(field)) {
    if (
      !(
        typeof newVal === "number" ||
        (typeof newVal === "string" &&
          /^\d+$/.test(newVal) &&
          Number.isInteger(Number(newVal)) &&
          Number(newVal) > 0)
      )
    ) {
      notNum = true;
    }
  }
  if (decFields.includes(field)) {
    if (
      !(
        typeof newVal === "number" ||
        (typeof newVal === "string" &&
          !isNaN(Number(newVal)) &&
          Number(newVal) > 0)
      )
    ) {
      notDec = true;
    }
  }
  if (fixedLengthFields.includes(field)) {
    if (newVal.length !== lengthMap[field]) {
      invalidLength = true;
    }
  }
  if (dateFields.includes(field)) {
    if (newVal !== undefined && !moment(moment(newVal).format("MM/DD/YYYY"), "MM/DD/YYYY", true).isValid()) {
      invalidDate = true;
    }
    if (!invalidDate && field === 'endDate' && moment().isBefore(moment(newVal))) {
      earlyBillDate = true;
    }

  }
  if (genderFields.includes(field)) {
    if (newVal !== "M" && newVal !== "F") {
      invalidGender = true;
    }
  }
  if (nameFields.includes(field)) {
    if (! /^[a-z ,.'-]+$/i.test(String(newVal))) {
      invalidName = true;
    }
  }
  if (alphanumericFields.includes(field)) {
    if (! /^[a-z0-9/:]+$/i.test(String(newVal).replaceAll(".", "").toUpperCase()) && mandatoryFields.includes(field)) {
      invalidAlphanum = true;
    }
  }
  if (field === "DiagnosisCode") {
    if (! /^[a-z0-9/]+$/i.test(String(newVal).replaceAll(".", "").toUpperCase())) {
      invalidDiagnosisCode = true;
    }
  }
  if (field === "payerId") {
    if (!payerList.map(p => String(p.payerId)).includes(String(newVal))) {
      invalidPayerId = true;
    }
  }
  return {
    empty,
    notNum,
    notDec,
    invalidDate,
    invalidGender,
    invalidLength,
    invalidName,
    invalidAlphanum,
    invalidDiagnosisCode,
    earlyBillDate,
    invalidPayerId
  };
};

const useCheckClaimField = () => {
  return useCallback(
    (params, payerList, NJMMIS) =>
      new Promise((resolve, reject) =>
        setTimeout(() => {
          let errors = checkClaim(params.field, params.value, payerList, NJMMIS);
          let errorPresent = Object.values(errors).filter((p) => p === true).length !== 0;
          if (errorPresent) {
            if (errors.empty) {
              reject(
                new Error("Error while saving user. This field can't be empty.")
              );
            } else if (errors.notNum) {
              reject(
                new Error(
                  "Error while saving user. This field has to be a number."
                )
              );
            } else if (errors.invalidDate) {
              reject(
                new Error(
                  "Error while saving user. This field has to be a valid date in MM/DD/YYYY format."
                )
              );
            } else if (errors.invalidGender) {
              reject(
                new Error(
                  "Error while saving user. Please select one from M/F."
                )
              );
            } else if (errors.notDec) {
              reject(
                new Error(
                  "Error while saving user. This field has to be a decimal."
                )
              );
            } else if (errors.invalidLength) {
              if (params.field === "priorAuth") {
                reject(
                  new Error(
                    "Error while saving user. This field has to be of length 10 and should start from 01 through 15."
                  )
                );
              }
            } else if (errors.invalidPayerId) {
              reject(
                new Error(
                  "Error while saving user. This field has to be one of the payer ids added to your agency."
                )
              );
            }
          } else {
            resolve({ id: params.id, [params.field]: params.value });
          }
        }, 200)
      ),
    []
  );
};

export default function Claims(props) {
  const [gridId, setGridId] = useState(48);
  const apiRef = useGridApiRef();
  let currClaimsList = useRef([]);

  const [payerList, setPayerList] = useState([]);
  const [claimsList, setClaimsList] = useState([]);
  const [currentMonth, setCurrMonth] = useState(moment().startOf("month"));
  const [currentMonthEnd, setCurrMonthEnd] = useState(moment().startOf("month").add(1, "month"));
  const [isLoading, setLoading] = useState(true);
  const [isLoadingApiCall, setLoadingApiCall] = useState(false);
  const [editNote, setEditNote] = useState(false);
  const [editRow, setEditRow] = useState(null);
  const [noteText, setNoteText] = useState('');
  const [bulkEditModal, setBulkEditModal] = useState(false);
  const [bulkEditMode, setBulkEditMode] = useState("");
  const [bulkEdittedVal, setBulkEdittedVal] = useState("");
  const [nextStepStatus, setNextStep] = useState(false);
  const [delClaimsStatus, setDelClaim] = useState(false);
  const [selectedClaims, setSelectedClaims] = useState([]);
  const [csvAdd, setCsvAdd] = useState(false);
  const [updateData, setUpdateData] = useState(false);
  const [selectionModel, setSelectionModel] = useState({ type: 'include', ids: new Set() });
  const [selectValidClaims, setSelectValidClaims] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showDelModal, setShowDelModal] = useState(false);
  const [snackbar, setSnackbar] = useState(null);
  const [loggedToSegment, setLoggedToSegment] = useState(false);
  const [companyData, setCompanyData] = useState({});
  const [editStatusMode, setEditStatusMode] = useState(false);
  const [initGridDataLoading, setInitGridDataLoading] = useState(true);
  const [gridDataLoading, setGridDataLoading] = useState(true);
  const [newClaimCMSForm, setNewClaimCMSForm] = useState(false);
  const [expectedTotal, setExpectedTotal] = useState(-1);
  const [noteUpdated, setNoteUpdated] = useState(false);
  const [colVisModel, setColVisModel] = useState({
    // Hide columns status and traderName, the other columns will remain visible
    id: false,
    claim_ID: false,
    patientAddrLine1: false,
    patientCity: false,
    patientState: false,
    patientZip: false,
    placeOfServiceCode: false,
  });
  const formDisplayContent = useRef({});
  const [showFormModal, setShowFormModal] = useState(false);
  const [errorKeys, setErrorKeys] = useState([]);
  const [formErrors, setFormErrors] = useState([]);
  const performChecks = useCheckClaimField();
  const [density, setDensity] = useState("standard");
  const [initialSettings, setInitialSettings] = useState({
    sorting: {
      sortModel: [{ field: "CreateDate", sort: "desc" }],
    },
    pagination: { paginationModel: { pageSize: 25 } },
  });
  const [orderedColumns, setOrderedColumns] = useState(props.columns ? props.columns.reduce((acc, col) => ([...acc, col.field]), []) : []);

  const handleCloseSnackbar = () => setSnackbar(null);
  let currentAbortController = null;
  // The csvAdd effect fires on mount too, duplicating the initial load and
  // aborting it mid-flight; skip that first run so it only reacts to toggles.
  const csvAddMounted = useRef(false);

  const logToSegment = () => {
    if (loggedToSegment) {
      return;
    }
    let page = String(window.location.href).split("/").pop()

    if (page.includes("fieldworker") || page === "" || page === "#") {
      page = "Home";
    } else {
      page = String(page).charAt(0).toUpperCase() + String(page).toLowerCase().slice(1);
    }

    analytics.page(page + " : Claims", {
      title: page + " : Claims",
      path: page + " : Claims",
    }, {
      userId: String(props.user.emp_id),
    })

    setLoggedToSegment(true);
  }

  const handleCellEditCommit = useCallback(
    async (updatedRow, originalRow) => {
      try {
        let p = undefined;
        for (let [key, value] of Object.entries(updatedRow)) {
          if (updatedRow[key] !== originalRow[key]) {
            p = {
              "field": key,
              "value": typeof (value) === "string" ? value.trim() : value,
              "id": updatedRow["id"],
            }
          }
        }
        if (p === undefined) {
          setSnackbar({
            children: "Claim successfully saved.",
            severity: "success",
          });
          return updatedRow;
        }
        setEditStatusMode(false);

        if (p.field === 'notes') {
          return;
        }
        let params;
        if (typeof (p.value) === "string" && p.value.includes(",")) {
          throw { message: "Please use '/' as a seperator instead of a ','." };
        }
        if (["FirstName", "LastName"].includes(p.field) && ! /^[a-z ,.'-]+$/i.test(String(p.value))) {
          throw { message: "Names can only contain letters, commas, periods, hyphens and single quotation marks." };
        }
        if (String(p.value).trim() !== '' && (["procedureCode", "procedureModifierCode"].includes(p.field) && ! /^[a-z0-9/:]+$/i.test(String(p.value).replaceAll(".", "").toUpperCase()))) {
          throw { message: "This field only supports alphanumeric characters, backslashes and colons without spaces." };
        }
        if (["DiagnosisCode"].includes(p.field) && ! /^[a-z0-9/]+$/i.test(String(p.value).replaceAll(".", "").toUpperCase())) {
          throw { message: "This field only supports alphanumeric characters and backslashes without spaces." }
        }
        if (["Gender", "procedureCode", "procedureModifierCode", "DiagnosisCode"].includes(p.field)) {
          params = { ...p, value: String(p.value).replaceAll(".", "").toUpperCase() };
        } else {
          params = { ...p };
        }
        updatedRow[params.field] = params.value;
        if (["Gender", "procedureCode", "procedureModifierCode", "DiagnosisCode"].includes(p.field) && currClaimsList.current.filter((claim) => claim.id === params.id)[0][params.field] === params.value && currClaimsList.current.filter((claim) => claim.id === params.id)[0][params.field] !== p.value) {
          throw { message: "No lower case letters allowed for this field." };
        }
        if (currClaimsList.current.filter((claim) => claim.id === params.id)[0][params.field] !== params.value) {
          const response = await performChecks(params, payerList, params.field !== 'payerId' ? payerList.find(p => p.payerId == currClaimsList.current.find((claim) => claim.id === params.id).payerId)?.payerDets.payer_name === 'NJ Medicaid' : payerList.find(p => p.payerId == params.value)?.payerDets.payer_name === 'NJ Medicaid');

          if (currClaimsList.current.filter((claim) => claim.id === params.id)[0]["claim_ID"] !== undefined) {
            let updateResult = await updateClaimData(
              [currClaimsList.current.filter((claim) => claim.id === params.id)[0]
                .claim_ID],
              params.field,
              params.value === null ? "" : params.value
            );
            if (updateResult.code >= 400) {
              throw { message: updateResult.message };
            }
          } else {
            errorChecker(currClaimsList.current.find((c) => c.id === params.id), params.id, payerList);

            if (currClaimsList.current[params.id].isSubmittable) {
              await insertClaimData(currClaimsList.current[params.id]);
            }
          }
          if (response.id !== undefined) {
            currClaimsList.current.map((claim) => {
              if (claim.id === params.id) {
                claim[params.field] = params.value;
              }
            });
            currClaimsList.current.map((claim) => {
              if (claim.id === params.id) {
                errorChecker(claim, claim.id, payerList);
              }
            });
          }
          if (currClaimsList.current.filter((claim) => claim.id === params.id)[0]["Status"] === 'Denied' || currClaimsList.current.filter((claim) => claim.id === params.id)[0]["Status"] === 'Pending' || currClaimsList.current.filter((claim) => claim.id === params.id)[0]["Status"] === 'Rejected') {
            let updateResult = await updateClaimData(
              [currClaimsList.current.filter((claim) => claim.id === params.id)[0]
                .claim_ID],
              "Status",
              "Ready to Bill"
            );
            if (updateResult.code >= 400) {
              throw { message: updateResult.message };
            }
            currClaimsList.current.map((claim) => {
              if (claim.id === params.id) {
                claim["Status"] = "Ready to Bill";
                errorChecker(claim, claim.id, payerList);
              }
            });
          }
          setClaimsList(currClaimsList.current);
          setUpdateData(!updateData);
          setSnackbar({
            children: "Claim successfully saved.",
            severity: "success",
          });
          return updatedRow;
        }
      } catch (error) {
        setSnackbar({ children: error.message, severity: "error" });
        return originalRow;
      }
    },
    [performChecks, claimsList, payerList]
  );

  const handleAddRow = () => {
    let newClaimObj = {
      id: currClaimsList.current.length,
      DDDID: "",
      FirstName: "",
      LastName: "",
      DateOfBirth: "",
      Gender: "",
      patientAddrLine1: "",
      patientCity: "",
      patientState: "",
      patientZip: "",
      placeOfServiceCode: "",
      patientRel: "",
      payerId: String(payerList.find((p) => p.default_payer === true).payerId),
      payerName: String(payerList.find((p) => p.default_payer === true).payerDets.payer_name),
      memberMedicaid: "",
      priorAuth: "",
      procedureCode: "",
      procedureModifierCode: "",
      startDate: "",
      endDate: "",
      DiagnosisCode: "",
      placeOfServiceCode: "99",
      authUnits: 0,
      authAmount: 0,
      totalCharges: 0,
      errors: "",
      Status: "Ready to Bill",
      Response: "",
      CreateDate: moment().tz('America/New_York').toISOString(),
      LastResponseDate: "",
      errCode: "",
      errDescription: "",
      source: "Manual entry",
      isSubmittable: false,
    };
    insertClaimData(newClaimObj);
  }

  async function updateClaimData(ids, colName, newVal) {
    if (colName === 'billingNote') {
      return;
    }
    if (!ids || ids.length === 0) {
      return { code: 400, message: 'No claims selected', success: [], total: 0 };
    }
    let claims = await axios.put(APIURL + "/claims", {
      claim_IDs: ids,
      colName: colName,
      newVal: newVal,
      currentClaimsData: currClaimsList.current.filter((c) => ids.includes(c.claim_ID)),
    });
    let result = {
      code: claims.data.code,
      message: claims.data.message,
      success: claims.data?.details?.successfulUpdates > 0 ? claims.data.details.updatedClaimIDs : [],
      total: claims.data?.details?.totalRequested
    }
    console.log(result);
    return result;
  }

  const handleFormModal = async function () {
    setShowFormModal(!showFormModal);
    setFormErrors([]);
    setErrorKeys([]);
  }

  async function getAllData(start, end) {
    if (currentAbortController) {
      currentAbortController.abort();
    }

    currentAbortController = new AbortController();
    const signal = currentAbortController.signal;

    try {
      setGridDataLoading(true);
      setInitGridDataLoading(true);
      setExpectedTotal(0);

      let getGridSettings = await axios.get(`${APIURL}/datagrid`, {
        params: { user_id: props.user.emp_id, report_id: gridId },
        signal
      });

      if (signal.aborted) return;

      if (getGridSettings.data.length > 0) {
        let settings = JSON.parse(getGridSettings.data[0].settings);
        setInitialSettings({ ...settings });
        setColVisModel({ ...colVisModel, ...settings.columnVisibilityModel });
        setDensity(settings.density ? settings.density : "standard");
        setOrderedColumns(settings.columns ? settings.columns.orderedFields : []);
      } else {
        let settings = props.initialState ? props.initialState : {};
        setInitialSettings({ ...settings });

        settings = settings ? JSON.stringify(settings) : JSON.stringify({});
        let saveGridSettings = await axios.post(`${APIURL}/datagrid`, {
          user_id: props.user.emp_id,
          report_id: gridId,
          settings: settings,
          signal
        });
      }

      if (signal.aborted) return;

      axios.defaults.headers = {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept, Authorization",
        "Access-Control-Allow-Methods": "PUT, GET, POST, DELETE, OPTIONS",
        "ACCESS-CONTROL-ALLOW-CREDENTIAL": true,
        Authorization:
          "Bearer " + window.localStorage.getItem("Fw4_access_Token"),
      };

      let payerDetails = await axios.get(APIURL + `/associate_payer`, {
        params: {
          compId: props.comp_id,
        },
        signal
      });

      if (signal.aborted) return;
      setPayerList(payerDetails.data);

      let compData = await axios.get(APIURL + `/company`, {
        params: {
          comp_id: props.comp_id,
        },
        signal
      });

      if (signal.aborted) return;
      setCompanyData(compData.data[0]);
      let claims = await axios.get(APIURL + "/claims", {
        params: { companyID: props.comp_id, startDate: start, endDate: end, page: 1, limit: 500 },
        signal
      });

      setExpectedTotal(claims.data.total);

      if (signal.aborted) return;

      let allClaims = claims.data.claims;
      currClaimsList.current = allClaims;

      let id_num = 0;
      currClaimsList.current.forEach((claim) => {
        errorChecker(claim, id_num, payerDetails.data);  // Updated function call
        claim.id = id_num++;
      });

      if (signal.aborted) return;

      setClaimsList([...currClaimsList.current]);
      setLoading(false);
      setInitGridDataLoading(false);

      const totalPages = Math.ceil(claims.data.total / 100);
      for (let page = 2; page <= totalPages; page++) {
        if (signal.aborted) break;  // Check abort in loop

        await new Promise((resolve) =>
          setTimeout(async () => {
            if (signal.aborted) {  // Check abort at start of timeout
              resolve();
              return;
            }

            const moreClaims = await axios.get(APIURL + "/claims", {
              params: {
                companyID: props.comp_id,
                startDate: start,
                endDate: end,
                page,
                limit: 500,
                totalCount: claims.data.total
              },
              signal  // Add signal to pagination calls
            });

            if (signal.aborted) {  // Check abort after API call
              resolve();
              return;
            }

            currClaimsList.current = [...currClaimsList.current, ...moreClaims.data.claims];
            moreClaims.data.claims.forEach((claim) => {
              errorChecker(claim, id_num, payerDetails.data);  // Updated function call
              claim.id = id_num++;
            });

            if (!signal.aborted) {  // Check abort before state update
              setClaimsList([...currClaimsList.current]);
            }
            resolve();
          }, 200)
        );
      }
    } catch (error) {
      // axios rejects aborted requests with its own Cancel object (no `name`),
      // so isCancel is the reliable check; error.name covers a native abort.
      if (axios.isCancel(error) || error.name === 'AbortError') {
        console.log('Request cancelled - user changed month');
        return;
      }
      console.error('Error loading data:', error);
    } finally {
      currentAbortController = null;
      console.log('Data loading complete');
    }
  }

  async function insertClaimData(obj) {
    obj["companyID"] = props.user.comp_id;
    obj["uploadedBy"] = props.user.emp_id;
    currClaimsList.current = [...currClaimsList.current, obj];
    setClaimsList(currClaimsList.current);
    setNewClaimCMSForm(true);
    processData(payerList, obj);
    setShowFormModal(true);

  }

  function errorChecker(claim, id, payerList) {
    let fieldToHeader = {
      DDDID: "DDDID",
      FirstName: "Patient First Name",
      LastName: "Patient Last Name",
      DateOfBirth: "Patient DOB",
      Gender: "Gender",
      memberMedicaid: "Medicaid ID",
      priorAuth: "Prior Authorization",
      procedureCode: "Procedure Code",
      startDate: "Task Start Date",
      endDate: "Task End Date",
      DiagnosisCode: "Diagnosis Code",
      authUnits: "Authorized Units",
      authAmount: "Authorized Amount",
      payerId: "Payer Id",
      patientCity: "Patient City",
      patientState: "Patient State",
      patientZip: "Patient Zip",
      patientAddrLine1: "Patient Address Line 1",
    };

    let allErrors = [];

    for (const [key, val] of Object.entries(claim)) {
      if (key in fieldToHeader) {
        var errors = checkClaim(key, val, payerList, payerList.find(p => p.payerId == claim.payerId)?.payerDets.payer_name === 'NJ Medicaid');
        if (errors.empty) {
          allErrors.push(`${fieldToHeader[key]} can't be empty.`);
        } else if (errors.notNum) {
          allErrors.push(`${fieldToHeader[key]} has to be a number.`);
        } else if (errors.notDec) {
          allErrors.push(`${fieldToHeader[key]} has to be a decimal.`);
        } else if (errors.invalidDate) {
          allErrors.push(`${fieldToHeader[key]} has to be a valid date(MM/DD/YYYY).`);
        } else if (errors.invalidGender) {
          allErrors.push(`${fieldToHeader[key]} has to be either M or F.`);
        } else if (errors.invalidLength) {
          if (key === "priorAuth") {
            allErrors.push(`${fieldToHeader[key]} has to be of length 10 and has to start from 01 through 15.`);
          }
        } else if (errors.invalidName) {
          allErrors.push(`${fieldToHeader[key]} can only contain letters, commas, periods, hyphens and single quotation marks.`);
        } else if (errors.invalidAlphanum) {
          allErrors.push(`${fieldToHeader[key]} only supports alphanumeric characters, backslashes and colons without spaces.`);
        } else if (errors.invalidDiagnosisCode) {
          allErrors.push(`${fieldToHeader[key]} only supports alphanumeric characters and backslashes without spaces.`);
        } else if (errors.earlyBillDate) {
          allErrors.push(`${fieldToHeader[key]} should be same or before today's date.`);
        } else if (errors.invalidPayerId) {
          allErrors.push(`${fieldToHeader[key]} has not been added to your company, add it to your company from your company settings first.`)
        }
      }
    }

    // Set errors and isSubmittable on the claim object
    claim.errors = allErrors;
    claim.isSubmittable =
      allErrors.length === 0 &&
      (["Ready to Bill"].includes(claim.Status) && !["Deferred"].includes(claim.Status));

    return claim;
  }

  useEffect(() => {
    console.log(moment().startOf('month'));
    logToSegment();
    getAllData(moment().startOf('month').format('YYYY-MM-DD'), moment().startOf('month').add(1, 'month').format('YYYY-MM-DD'));
  }, []);

  useEffect(() => {
    async function sendToBilling(data, newList) {
      setLoadingApiCall(true);
      let billingStatus = await axios
        .post(APIURL + "/medicaid/claimmd", {
          entries: data,
          comp_id: props.user.comp_id,
          emp_id: props.user.emp_id,
          empName: props.user.emp_name,
          companyName: props.user.company_name,
        })
        .then(
          async (response) => {
            if (!response.data.njResp) {
              currClaimsList.current = newList;
              let ids = claimsList
                .filter((claim) => selectionModel.ids.has(claim.id))
                .map((claim) => claim.claim_ID);
              let updateResult = await updateClaimData(ids, "Status", "Released");
              if (updateResult.code >= 400) {
                throw { message: updateResult.message };
              }
              currClaimsList.current = claimsList;
              for (let id of selectionModel.ids) {
                currClaimsList.current[id]["Status"] =
                  "Released";
                currClaimsList.current[id][
                  "isSubmittable"
                ] = false;
              }
              setLoadingApiCall(false);
              setClaimsList(currClaimsList.current);
              setUpdateData(!updateData);
              setSelectValidClaims(false);
              setNextStep(false);
              setSelectionModel({ ...selectionModel, ids: new Set() });
              setSnackbar({
                children: "Claims sent!",
                severity: "success",
              });
              return;
            }
            let upres = response.data.njResp;
            const objX12 = {
              comp_id: props.user.comp_id,
              emp_name: props.user.emp_name,
              fileName: String(upres.id),
              fileLocation: `${upres.url}`,
              claim_IDs: data.map((d) => d.claim_ID),
              Status: "READY",
              SubmitDate: moment().toISOString(),
            };
            let billingX12Status = await axios
              .post(APIURL + "/generateX12", objX12)
              .then(
                async (resp) => {
                  currClaimsList.current = newList;
                  let ids = claimsList
                    .filter((claim) => selectionModel.ids.has(claim.id))
                    .map((claim) => claim.claim_ID);
                  let updateResult = await updateClaimData(ids, "Status", "Released");
                  if (updateResult.code >= 400) {
                    throw { message: updateResult.message };
                  }
                  currClaimsList.current = claimsList;
                  for (let id of selectionModel.ids) {
                    currClaimsList.current[id]["Status"] =
                      "Released";
                    currClaimsList.current[id][
                      "isSubmittable"
                    ] = false;
                  }

                  setLoadingApiCall(false);
                  setClaimsList(currClaimsList.current);
                  setUpdateData(!updateData);
                  setSelectValidClaims(false);
                  setNextStep(false);
                  setSelectionModel({ ...selectionModel, ids: new Set() });
                  setSnackbar({
                    children: "The file has been generated!",
                    severity: "success",
                  });
                },
                (error) => {
                  console.log(error);

                  setLoadingApiCall(false);
                  setClaimsList(currClaimsList.current);
                  setUpdateData(!updateData);
                  setSelectValidClaims(false);
                  setNextStep(false);
                  setSelectionModel({ ...selectionModel, ids: new Set() });
                  setSnackbar({
                    children: "Something went wrong. Try again!",
                    severity: "error",
                  });
                }
              );
          },
          (error) => {
            console.log(error);

            setLoadingApiCall(false);
            setClaimsList(currClaimsList.current);
            setUpdateData(!updateData);
            setSelectValidClaims(false);
            setNextStep(false);
            setSelectionModel({ ...selectionModel, ids: new Set() });
            setSnackbar({
              children: "Something went wrong. Try again!",
              severity: "error",
            });
          }
        );
    }

    if (nextStepStatus) {
      if (selectionModel.ids.size !== 0) {
        let dataToBeSent = claimsList.filter((claim) =>
          selectionModel.ids.has(claim.id)
        );
        sendToBilling(dataToBeSent, claimsList);
      }
    }
  }, [nextStepStatus]);

  useEffect(() => {
    console.log(claimsList.length, expectedTotal);
    if (expectedTotal >= 0 && claimsList.length === expectedTotal) {
      console.log("All data loaded, setting gridDataLoading to false");
      setGridDataLoading(false);
    }
  }, [claimsList.length, expectedTotal, currentMonth, currentMonthEnd]);

  useEffect(() => {

    async function delClaims(validData, invalidData) {
      setLoadingApiCall(true);
      let invalidIds = invalidData.map((claim) => claim.id);
      currClaimsList.current = currClaimsList.current.filter((claim) => !invalidIds.includes(claim.id));
      currClaimsList.current.forEach((claim, index) => {
        claim.id = index;
      })
      let validIds = validData.filter((claim) => claim.claim_ID !== undefined).map((claim) => claim.claim_ID);
      if (validIds.length !== 0) {
        let resp = await axios.delete(APIURL + "/claims", {
          data: {
            idsToBeDeleted: validIds,
            empId: props.user.emp_id,
            compId: props.user.comp_id,
          }
        });
        currClaimsList.current = currClaimsList.current.filter((claim) => !validIds.includes(claim.claim_ID))
      }
      currClaimsList.current.forEach((claim, index) => {
        claim.id = index;
      })
      setClaimsList(currClaimsList.current);
      setSelectionModel({ ...selectionModel, ids: new Set() });
      setSnackbar({
        children: "Claims successfully deleted!",
        severity: "success",
      })
      setLoadingApiCall(false);
      setDelClaim(!delClaimsStatus);
    }

    if (delClaimsStatus) {
      if (selectionModel.ids.size !== 0) {
        let dataToBeDeleted = Array.from(selectionModel.ids).map((id) => {
          return currClaimsList.current[id];
        })
        let validClaims = dataToBeDeleted.filter((claim) => claim.claim_ID !== undefined)
        let invalidClaims = dataToBeDeleted.filter((claim) => claim.claim_ID === undefined)
        delClaims(validClaims, invalidClaims);
      }
    }
  }, [delClaimsStatus])

  useEffect(() => {
    if (!csvAddMounted.current) {
      csvAddMounted.current = true;
      return;
    }
    getAllData(currentMonth.format('YYYY-MM-DD'), currentMonthEnd.format('YYYY-MM-DD'));
  }, [csvAdd]);

  useEffect(() => {
    if (noteUpdated) {
      console.log("note updated, refreshing data");
      setNoteUpdated(false);
      getAllData(currentMonth.format('YYYY-MM-DD'), currentMonthEnd.format('YYYY-MM-DD'));
    }
  }, [noteUpdated]);

  useEffect(() => {
    if (selectValidClaims) {
      let readyToSubmitRows = claimsList
        .filter((r) => r.isSubmittable && moment(r.CreateDate).month() === currentMonth.month() && moment(r.CreateDate).year() === currentMonth.year())
        .map((r) => r.id);
      setSelectionModel({ ...selectionModel, ids: new Set(readyToSubmitRows) });
    } else {
      setSelectionModel({ ...selectionModel, ids: new Set() });
    }
  }, [selectValidClaims]);

  useEffect(() => {
    getClaimsList();
  }, [updateData]);

  async function updateBillingNote(id, note, cid) {
    try {
      if (note && note.replace(/\s/g, '').length !== 0) {
        await axios.put(APIURL + "/accountsReceivable/billingNote", {
          billing_note_id: id,
          billing_note: note,
          empID: props.user.emp_id,
        });
        currClaimsList.current = currClaimsList.current.map((claim) => {
          if (claim.claim_ID === cid) {
            claim.billing_note = note;
          }
          return claim;
        })
        setClaimsList(currClaimsList.current);
        setSnackbar({
          children: "Note successfully saved.",
          severity: "success",
        });
      } else {
        setSnackbar({
          children: "Note cannot be empty",
          severity: "error"
        });
      }
    } catch (error) {
      setSnackbar({
        children: error.message,
        severity: "error"
      });
    }
    setEditNote(false);
    setEditRow(null);
  }

  async function bulkUpdateSelected() {
    try {
      if (bulkEditMode === 'authAmount') {
        let val = parseFloat(bulkEdittedVal);
        if (isNaN(val)) {
          setSnackbar({
            children: "Amount should be a valid decimal, please try again.",
            severity: "error"
          });
        } else {
          let updateResult = await updateClaimData(currClaimsList.current.filter((claim, index) => selectionModel.ids.has(index)).map((claim) => claim.claim_ID), bulkEditMode, bulkEdittedVal);
          let message = null;
          if (updateResult.code >= 400) {
            throw { message: updateResult.message };
          } else {
            message = updateResult.message;
          }
          currClaimsList.current = currClaimsList.current.map((claim, ind) => {
            if (selectionModel.ids.has(ind) && updateResult.success.includes(claim.claim_ID)) {
              claim[bulkEditMode] = bulkEdittedVal;
            }
            return claim;
          })
          setClaimsList(currClaimsList.current);
          setSnackbar({
            children: message !== null ? message : "Bulk edit success.",
            severity: "success",
          });
        }
      } else if (bulkEditMode === 'Status') {
        let updateResult = await updateClaimData(currClaimsList.current.filter((claim, index) => selectionModel.ids.has(index)).map((claim) => claim.claim_ID), bulkEditMode, bulkEdittedVal);
        let message = null;
        if (updateResult.code >= 400) {
          throw { message: updateResult.message };
        } else {
          message = updateResult.message;
        }
        currClaimsList.current = currClaimsList.current.map((claim, ind) => {
          if (selectionModel.ids.has(ind) && updateResult.success.includes(claim.claim_ID)) {
            claim[bulkEditMode] = bulkEdittedVal;
            if (bulkEdittedVal === 'Deferred') {
              claim.isSubmittable = false;
            }
          }
          return claim;
        })
        setClaimsList(currClaimsList.current);
        setSnackbar({
          children: message !== null ? message : "Bulk edit success.",
          severity: "success",
        });
      } else if (bulkEditMode === 'placeOfServiceCode') {
        let updateResult = await updateClaimData(currClaimsList.current.filter((claim, index) => selectionModel.ids.has(index)).map((claim) => claim.claim_ID), bulkEditMode, bulkEdittedVal);
        let message = null;
        if (updateResult.code >= 400) {
          throw { message: updateResult.message };
        } else {
          message = updateResult.message;
        }
        currClaimsList.current = currClaimsList.current.map((claim, ind) => {
          if (selectionModel.ids.has(ind) && updateResult.success.includes(claim.claim_ID)) {
            claim[bulkEditMode] = bulkEdittedVal;
          }
          return claim;
        })
        setClaimsList(currClaimsList.current);
        setSnackbar({
          children: message !== null ? message : "Bulk edit success.",
          severity: "success",
        });
      } else if (bulkEditMode === 'payerId') {
        let val = parseInt(bulkEdittedVal);
        if (isNaN(val)) {
          setSnackbar({
            children: "Payer Id should be a valid number, please try again.",
            severity: "error"
          });
        } else {
          let updateResult = await updateClaimData(currClaimsList.current.filter((claim, index) => selectionModel.ids.has(index)).map((claim) => claim.claim_ID), bulkEditMode, bulkEdittedVal);
          let message = null;
          if (updateResult.code >= 400) {
            throw { message: updateResult.message };
          } else {
            message = updateResult.message;
          }
          currClaimsList.current = currClaimsList.current.map((claim, ind) => {
            if (selectionModel.ids.has(ind) && updateResult.success.includes(claim.claim_ID)) {
              claim[bulkEditMode] = bulkEdittedVal;
            }
            return claim;
          })
          setClaimsList(currClaimsList.current);
          setSnackbar({
            children: message !== null ? message : "Bulk edit success.",
            severity: "success",
          });
        }
      }
    } catch (error) {
      setSnackbar({
        children: error.message,
        severity: "error"
      });
    }
    setBulkEditModal(false);
    setBulkEditMode("");
    setBulkEdittedVal("");
  }

  async function addBillingNote(id, note) {
    try {
      if (note && note.replace(/\s/g, '').length !== 0) {
        const resp = await axios.post(APIURL + "/accountsReceivable/billingNote", {
          claim_id: id,
          billing_note: note,
          empID: props.user.emp_id,
        });
        console.log(resp, "billing note response");
        currClaimsList.current = currClaimsList.current.map((claim) => {
          if (claim.claim_ID === id) {
            claim.billing_note = note;
          }
          return claim;
        })
        setNoteUpdated(true);
        setClaimsList(currClaimsList.current);
        setSnackbar({
          children: "Note successfully saved.",
          severity: "success",
        });
      } else {
        setSnackbar({
          children: "Note cannot be empty",
          severity: "error"
        });
      }
    } catch (error) {
      setSnackbar({
        children: error.message,
        severity: "error"
      });
    }
    setEditNote(false);
    setEditRow(null);
  }

  function handleConfirmModal() {
    let notSubmittableClaims = claimsList.filter((r) => !r.isSubmittable).map((r) => r.id);
    if (selectionModel.ids.size !== 0 && Array.from(selectionModel.ids).some((id) => notSubmittableClaims.includes(id))) {
      let finalValidIds = Array.from(selectionModel.ids).filter((id) => !notSubmittableClaims.includes(id));
      setSelectionModel({ ...selectionModel, ids: new Set(finalValidIds) });
      if (finalValidIds.length !== 0) {
        setShowModal(!showModal);
      }
      else {
        setShowModal(false);
        setSnackbar({
          children: "Only claims with 'Ready to Bill' status and without errors are submittable, please fix them before submitting.",
          severity: "error",
        })
      }
    }
    else {
      setShowModal(!showModal);
    }
  }

  function handleDelConfirmModal() {
    setShowDelModal(!showDelModal);
  }

  function getBackgroundColor(color, mode) {
    return mode === "dark" ? darken(color, 0.6) : lighten(color, 0.8);
  }

  function getHoverBackgroundColor(color, mode) {
    return mode === "dark" ? darken(color, 0.5) : lighten(color, 0.7);
  }

  function onSelect(id) {
    let selectedClaim = claimsList.find(
      (claim) => claim.id === id
    );
    setSelectedClaims(selectedClaim);
  }

  function toggleCSVAdd() {
    setCsvAdd(!csvAdd);
  }

  function renderCSVModal() {
    return (
      <Upload
        showUpload={csvAdd}
        setCsvAdd={setCsvAdd}
        toggleCSVAdd={toggleCSVAdd}
        user={props.user}
      ></Upload>
    );
  }

  async function onDateChange(newValue) {
    await getAllData(moment(newValue).startOf("month").format('YYYY-MM-DD'), moment(newValue).startOf("month").add(1, 'month').format('YYYY-MM-DD'));
    setCurrMonth(moment(newValue).startOf("month"));
    setCurrMonthEnd(moment(newValue).endOf("month"));
  }

  const debounce = (func, wait) => {
    let timeout;
    return (...args) => {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  };

  function getSelectButton() {
    return (
      <div style={{ marginTop: 15, marginLeft: 10, width: "45%" }}>
        <Box display="flex" justifyContent="flex-end" alignItems="flex-end">
          <Tooltip title="" disabled={isLoading || isLoadingApiCall || currClaimsList.current.filter((claim) => claim.isSubmittable === true && moment(claim.CreateDate).month() === currentMonth.month() && moment(claim.CreateDate).year() === currentMonth.year()).length === 0}>
            <Button
              variant="contained"
              fullWidth={true}
              onClick={() => {
                setSelectValidClaims(true);
              }}
              disabled={
                gridDataLoading ||
                isLoading ||
                isLoadingApiCall ||
                currClaimsList.current.filter(
                  (claim) =>
                    claim.isSubmittable === true &&
                    moment(claim.CreateDate).month() === currentMonth.month() &&
                    moment(claim.CreateDate).year() === currentMonth.year()
                ).length === 0
              }
            >
              Select Fileable Claims
            </Button>
          </Tooltip>
        </Box>
      </div>
    );
  }

  function getUnselectButton() {
    return (
      <div style={{ marginTop: 15, marginLeft: 10, width: "35%" }}>
        <Box display="flex">
          <Button
            variant="contained"
            sx={{ width: "80%" }}
            onClick={() => {
              setSelectValidClaims(false);
              setSelectionModel({ ...selectionModel, ids: new Set() });
            }}
            style={{
              backgroundColor: "white",
              color: "grey",
            }}
          >
            Unselect All
          </Button>
        </Box>
      </div>
    );
  }

  const handleSaveSettings = async () => {
    let settings = apiRef.current.exportState();
    settings.columnVisibilityModel = colVisModel;
    settings.density = density;
    settings = JSON.stringify(settings);

    let saveGridSettings = await axios.put(`${APIURL}/datagrid`, { user_id: props.user.emp_id, report_id: gridId, settings: settings });
  }

  const handleColumnOrderChange = (params) => {
    let newOrder = [];
    setOrderedColumns((prevOrderedColumns) => {
      if (prevOrderedColumns.length === 0) {
        return apiRef.current.exportState().columns.orderedFields;
      }
      const newOrderedColumns = [...prevOrderedColumns];
      const oldIndex = params.oldIndex;
      const targetIndex = params.targetIndex;
      const oldColumn = prevOrderedColumns[oldIndex];
      newOrderedColumns.splice(oldIndex, 1);
      newOrderedColumns.splice(targetIndex, 0, oldColumn);
      newOrder = newOrderedColumns;
      return newOrderedColumns;
    });
    setInitialSettings((prevSettings) => {
      return {
        ...prevSettings,
        columns: {
          ...prevSettings.columns,
          orderedFields: newOrder.length !== 0 ? newOrder : apiRef.current.exportState().columns.orderedFields,
        }
      }
    })
  };

  const handleCellDoubleClick = (params) => {
    if (params.field === "billingNote") {
      setEditNote(true);
      setEditRow(params.row);
      setNoteText(params.row.billingNote);
    }
    if (selectionModel.ids.size > 1 && (params.field === "Status" || params.field === "authAmount" || params.field === "placeOfServiceCode" || params.field === "payerId")) {
      setBulkEditMode(params.field);
      setBulkEditModal(true);
    }
    if (params.field === "Status" && selectionModel.ids.size <= 1 && !['Processed as Primary', 'Processed as Secondary', 'Denied'].includes(params.value)) {
      setEditStatusMode(true);
    }
  };

  function getSendButton() {
    return (
      <div style={{ marginTop: 15, width: "10%" }}>
        <Box display="flex" justifyContent="flex-end" alignItems="flex-end">
          <Button
            variant="contained"
            onClick={() => {
              handleConfirmModal();
            }}
            style={{
              backgroundColor: "green",
            }}
          >
            Send
          </Button>
        </Box>
      </div>
    );
  }

  function getClaimsList() {
    let displayClaims = currClaimsList.current;
    displayClaims = displayClaims.filter(
      (claim) =>
        moment(claim.CreateDate).month() === currentMonth.month() &&
        moment(claim.CreateDate).year() === currentMonth.year()
    );
    let rows = displayClaims.map((claim) => {
      let claimDets = {
        id: claim.id,
        claim_ID: claim.claim_ID,
        DDDID: claim.DDDID,
        FirstName: claim.FirstName,
        payerId: claim.payerId,
        LastName: claim.LastName,
        DateOfBirth: moment(claim.DateOfBirth).isValid() ? moment(claim.DateOfBirth).utc().format("L") : "",
        Gender: claim.Gender,
        memberMedicaid: claim.memberMedicaid,
        priorAuth: claim.priorAuth,
        procedureCode: claim.procedureCode,
        procedureModifierCode: claim.procedureModifierCode,
        startDate: moment(claim.startDate).isValid() ? moment(claim.startDate).utc().format("L") : "",
        endDate: moment(claim.endDate).isValid() ? moment(claim.endDate).utc().format("L") : "",
        DiagnosisCode: claim.DiagnosisCode,
        authUnits: claim.authUnits,
        authAmount: claim.authAmount,
        totalCharges: claim.authAmount,
        errors: claim.errors,
        Status: claim.Status,
        Response: claim.Response,
        CreateDate: claim.CreateDate,
        LastResponseDate: claim.LastResponseDate
          ? (moment(claim.LastResponseDate).isValid() ? moment(claim.LastResponseDate).utc().format("L") : "")
          : "",
        errCode: claim.errCode,
        errDescription: claim.errDescription,
        isSubmittable: claim.isSubmittable,
        billingNoteId: claim.billing_note_id,
        billingNote: claim.billing_note,
        patientAddrLine1: claim.patientAddrLine1,
        patientCity: claim.patientCity,
        patientState: claim.patientState,
        patientZip: claim.patientZip,
        patientRel: claim.patientRel,
        placeOfServiceCode: claim.placeOfServiceCode,
        source: claim.source,
      };
      return claimDets;
    });
    let cols = [
      {
        field: "id",
        headerName: "ID",
        width: 50,
        hide: true,
      },
      {
        field: "claim_ID",
        headerName: "ClaimID",
        hide: true,
      },
      {
        field: "DDDID",
        headerName: "DDDID",
        width: 80,
        hide: false,
        editable: true,
      },
      {
        field: "cmsForm",
        headerName: "1500 Form",
        width: 80,
        hide: false,
        renderCell: (params) => {
          const onClick = async () => {
            setNewClaimCMSForm(false);
            processData(payerList, params.row);
            setShowFormModal(true);
          }
          return (
            <div style={{ color: '#3FA7D6' }}>
              <Link href="#" underline="hover" onClick={onClick}>
                <AssignmentIcon fontSize="small" sx={{ marginRight: '5px' }} />
                View
              </Link>
            </div>
          );
        },
      },
      {
        field: "payerId",
        headerName: "Payer Id",
        width: 80,
        hide: false,
        editable: true,
        type: 'singleSelect',
        valueOptions: payerList.map((dets) => { return { label: dets.payer_name !== undefined ? dets.payer_name : dets.payerDets.payer_name, value: String(dets.payerId) } }),
        renderCell: (params) => (
          <Tooltip title="Double-click to change payer">
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', cursor: 'pointer' }}>
              <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{params.formattedValue}</span>
              <ArrowDropDownIcon fontSize="small" sx={{ color: 'action.active', flexShrink: 0 }} />
            </Box>
          </Tooltip>
        ),
      },
      {
        field: "FirstName",
        headerName: "Patient First Name",
        width: 90,
        hide: false,
        editable: true,
        headerAlign: "center",
        renderHeader: (params) => {
          return (
            <div
              style={{
                maxHeight: "inherit",
                width: "100%",
                whiteSpace: "initial",
                lineHeight: "16px",
                verticalAlign: "bottom",
              }}
            >
              Patient First Name
            </div>
          );
        },
        renderCell: (params) => {
          return (
            <Tooltip title={params.value}>
              <div style={{ overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", width: 100 }}>{params.value}</div>
            </Tooltip>
          );
        },
      },
      {
        field: "LastName",
        headerName: "Patient Last Name",
        width: 90,
        hide: false,
        editable: true,
        renderCell: (params) => {
          return (
            <Tooltip title={params.value}>
              <div style={{ overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", width: 100 }}>{params.value}</div>
            </Tooltip>
          );
        },
        renderHeader: (params) => {
          return (
            <div
              style={{
                maxHeight: "inherit",
                width: "100%",
                whiteSpace: "initial",
                lineHeight: "16px",
                verticalAlign: "bottom",
              }}
            >
              Patient Last Name
            </div>
          );
        },
      },
      {
        field: "DateOfBirth",
        headerName: "DOB",
        width: 100,
        hide: false,
        editable: true,
      },
      {
        field: "Gender",
        headerName: "Gender",
        width: 65,
        hide: false,
        editable: true,
      },
      {
        field: "patientAddrLine1",
        headerName: "Address Line 1",
        width: 150,
        hide: false,
        editable: true,
      },
      {
        field: "patientCity",
        headerName: "City",
        width: 90,
        hide: false,
        editable: true,
      },
      {
        field: "patientState",
        headerName: "State",
        width: 65,
        hide: false,
        editable: true,
      },
      {
        field: "patientZip",
        headerName: "Zip",
        width: 80,
        hide: false,
        editable: true,
      },
      {
        field: "priorAuth",
        headerName: "Prior Auth",
        width: 105,
        hide: false,
        editable: true,
        renderHeader: (params) => {
          return (
            <div
              style={{
                maxHeight: "inherit",
                width: "100%",
                whiteSpace: "initial",
                lineHeight: "16px",
                verticalAlign: "bottom",
              }}
            >
              Prior Authorization
            </div>
          );
        },
      },
      {
        field: "DiagnosisCode",
        width: 50,
        hide: false,
        headerName: "Diagnosis Code",
        editable: true,
        renderHeader: (params) => {
          return (
            <div
              style={{
                maxHeight: "inherit",
                width: "100%",
                whiteSpace: "initial",
                lineHeight: "16px",
                verticalAlign: "bottom",
              }}
            >
              Diag Code
            </div>
          );
        },
        renderCell: (params) => {
          return (
            <Tooltip title={params.value}>
              <div style={{ overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", width: 100 }}>{params.value}</div>
            </Tooltip>
          );
        },
      },
      {
        field: "memberMedicaid",
        headerName: "Medicaid ID",
        width: 120,
        hide: false,
        editable: true,
      },
      {
        field: "startDate",
        headerName: "Task Start Date",
        width: 100,
        hide: false,
        editable: true,
        sortComparator: dateComparator,
        renderHeader: (params) => {
          return (
            <div
              style={{
                maxHeight: "inherit",
                width: "100%",
                whiteSpace: "initial",
                lineHeight: "16px",
                verticalAlign: "bottom",
              }}
            >
              Task Start Date
            </div>
          );
        },
      },
      {
        field: "endDate",
        headerName: "Task End Date",
        width: 100,
        hide: false,
        editable: true,
        sortComparator: dateComparator,
        renderHeader: (params) => {
          return (
            <div
              style={{
                maxHeight: "inherit",
                width: "100%",
                whiteSpace: "initial",
                lineHeight: "16px",
                verticalAlign: "bottom",
              }}
            >
              Task End Date
            </div>
          );
        },
      },
      {
        field: "placeOfServiceCode",
        headerName: "Place of service code",
        width: 165,
        hide: false,
        editable: true,
        type: 'singleSelect',
        valueOptions: [{ label: '0 - Emergency Room (23)', value: '23' }, { label: "1 - Doctor's Office (11)", value: '11' }, { label: "2 - Patient's Home (12)", value: '12' }, { label: "3 - Inpatient Hospital (21)", value: '21' }, { label: '4 - Boarding Home (14)', value: '14' }, { label: "5 - Skilled Nursing Home (31)", value: '31' }, { label: "6 - Independent Laboratory (81)", value: '81' }, { label: "7 - Outpatient Hospital (22)", value: '22' }, { label: "8 - Clinic (49)", value: '49' }, { label: "9 - Other (99)", value: '99' }],
        renderCell: (params) => (
          <Tooltip title="Double-click to change place of service">
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', cursor: 'pointer' }}>
              <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{params.formattedValue}</span>
              <ArrowDropDownIcon fontSize="small" sx={{ color: 'action.active', flexShrink: 0 }} />
            </Box>
          </Tooltip>
        ),
      },
      {
        field: "authAmount",
        headerName: "Authorized Amount",
        width: 80,
        hide: false,
        editable: true,
        renderHeader: (params) => {
          return (
            <div
              style={{
                maxHeight: "inherit",
                width: "100%",
                whiteSpace: "initial",
                lineHeight: "16px",
                verticalAlign: "bottom",
              }}
            >
              Auth Amount
            </div>
          );
        },
      },
      {
        field: "authUnits",
        headerName: "Auth Units",
        width: 60,
        hide: false,
        editable: true,
        renderHeader: (params) => {
          return (
            <div
              style={{
                maxHeight: "inherit",
                width: "100%",
                whiteSpace: "initial",
                lineHeight: "16px",
                verticalAlign: "bottom",
              }}
            >
              Auth Units
            </div>
          );
        },
      },
      {
        field: "procedureCode",
        headerName: "Procedure Code",
        width: 100,
        editable: true,
        hide: false,
        renderHeader: (params) => {
          return (
            <div
              style={{
                maxHeight: "inherit",
                width: "100%",
                whiteSpace: "initial",
                lineHeight: "16px",
                verticalAlign: "bottom",
              }}
            >
              Procedure Code
            </div>
          );
        },
      },
      {
        field: "procedureModifierCode",
        headerName: "Procedure Code Modifier",
        width: 110,
        editable: true,
        hide: false,
        renderHeader: (params) => {
          return (
            <div
              style={{
                maxHeight: "inherit",
                width: "100%",
                whiteSpace: "initial",
                lineHeight: "16px",
                verticalAlign: "bottom",
              }}
            >
              Procedure Code Modifier
            </div>
          );
        },
      },
      {
        field: "totalCharges",
        headerName: "Total Charges",
        width: 80,
        hide: false,
        renderHeader: (params) => {
          return (
            <div
              style={{
                maxHeight: "inherit",
                width: "100%",
                whiteSpace: "initial",
                lineHeight: "16px",
                verticalAlign: "bottom",
              }}
            >
              Total Charges
            </div>
          );
        },
      },
      {
        field: "errors",
        headerName: "Claim Errors",
        width: 140,
        hide: false,
        sortComparator: (a, b) => {
          return a.length > b.length ? 100 : -1
        },
        renderCell: (params) => {
          return (
            <Tooltip title={params.value}>
              <span style={{ overflow: "hidden" }}>{params.value}</span>
            </Tooltip>
          );
        },
      },
      {
        field: "billingNote",
        headerName: "Notes",
        width: 300,
        editable: true,
        renderCell: (params) => {
          return (
            <Tooltip title={params.value}>
              <div style={{ overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", width: 100 }}>{params.value}</div>
            </Tooltip>
          );
        },
      },
      {
        field: "Status",
        headerName: "Claim Status",
        width: 200,
        hide: false,
        editable: true,
        type: 'singleSelect',
        valueOptions: editStatusMode ? ['Ready to Bill', 'Deferred'] : ['Ready to Bill', 'Deferred', 'Processed as Primary', 'Released', 'Pending', 'Processed as Secondary', 'Denied'],
        renderCell: (params) => (
          <Tooltip title="Double-click to change status">
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', cursor: 'pointer' }}>
              <span>{params.value}</span>
              <ArrowDropDownIcon fontSize="small" sx={{ color: 'action.active', flexShrink: 0 }} />
            </Box>
          </Tooltip>
        ),
      },
      {
        field: "Response",
        headerName: "Response Status",
        width: 130,
        hide: false,
        renderCell: (params) => {
          return (
            <Tooltip title={params.value}>
              <div style={{ overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", width: 100 }}>{params.value}</div>
            </Tooltip>
          );
        },
      },
      {
        field: "CreateDate",
        headerName: "Created Date",
        width: 130,
        hide: false,
        valueGetter: (value, row, column, apiRef) => ({
          createDate: row.CreateDate,
          procCode: row.procedureCode,
          procCodeModifer: row.procedureModifierCode,
          status: row.Status,
          isSubmittable: row.isSubmittable,
          errors: row.errors,
        }),
        valueFormatter: (value, row, column, apiRef) => moment(value.createDate).utc().format("MM/DD/YYYY"),
        sortComparator: dateProcCodeModifComparator,
      },
      {
        field: "LastResponseDate",
        headerName: "Last Response Date",
        width: 100,
        hide: false,
        sortComparator: dateComparator,
        renderHeader: (params) => {
          return (
            <div
              style={{
                maxHeight: "inherit",
                width: "100%",
                whiteSpace: "initial",
                lineHeight: "16px",
                verticalAlign: "bottom",
              }}
            >
              Last Response Date
            </div>
          );
        },
      },
      {
        field: "errCode",
        headerName: "Error Code",
        width: 120,
        hide: false,
        renderCell: (params) => {
          let displayVal = (params.row.Status?.includes('Processed')) ? "" : params.value;
          return (
            <Tooltip title={displayVal}>
              <div style={{ overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", width: 100 }}>{displayVal}</div>
            </Tooltip>
          );
        },
      },
      {
        field: "errDescription",
        headerName: "Error Description",
        width: 140,
        hide: false,
        renderCell: (params) => {
          return (
            <Tooltip title={params.value}>
              <div style={{ overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", width: 100 }}>{params.value}</div>
            </Tooltip>
          );
        },
      },
      {
        field: "source",
        headerName: "Source",
        width: 150,
        hide: true,
        renderCell: (params) => {
          return (
            <Tooltip title={params.value}>
              <div style={{ overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", width: 100 }}>{params.value}</div>
            </Tooltip>
          );
        },
      }
    ];

    if (initialSettings.columns) {
      cols = cols.sort((a, b) => {
        const indexA = initialSettings.columns.orderedFields.indexOf(a.field);
        const indexB = initialSettings.columns.orderedFields.indexOf(b.field);

        if (indexA === -1 && indexB === -1) return 0;

        if (indexA === -1) return 1;

        if (indexB === -1) return -1;

        return indexA - indexB;
      });
    }

    const toolbarButtons = [
      () => (
        <Tooltip title="Add a claim">
          <ToolbarButton onClick={handleAddRow} disabled={isLoading || isLoadingApiCall || gridDataLoading}>
            <AddIcon />
          </ToolbarButton>
        </Tooltip>
      ),
      () => (
        <Tooltip title="Delete claim">
          <ToolbarButton
            onClick={handleDelConfirmModal}
            disabled={isLoading || isLoadingApiCall || gridDataLoading || !selectionModel?.ids || selectionModel.ids.size === 0}
          >
            <DeleteIcon />
          </ToolbarButton>
        </Tooltip>
      )
    ];

    let claimsListFin = (
      <Box
        sx={{
          display: 'flex', flexDirection: 'column',
          "& .MuiDataGrid-row.super-app-theme--ReadytoBill--false": {
            bgcolor: (theme) =>
              getBackgroundColor(theme.palette.error.light, theme.palette.mode),
          },
          "& .MuiDataGrid-row.super-app-theme--ReadytoBill--false:hover": {
            bgcolor: (theme) =>
              getHoverBackgroundColor(
                theme.palette.error.light,
                theme.palette.mode
              ),
          },
          "& .MuiDataGrid-row.super-app-theme--CHECKPROCCODE": {
            bgcolor: (theme) =>
              getBackgroundColor(
                theme.palette.warning.light,
                theme.palette.mode
              ),
          },
          "& .MuiDataGrid-row.super-app-theme--CHECKPROCCODE:hover": {
            bgcolor: (theme) =>
              getHoverBackgroundColor(
                theme.palette.warning.light,
                theme.palette.mode
              ),
          },
          "& .MuiDataGrid-row.super-app-theme--ERROR--false": {
            bgcolor: (theme) =>
              getBackgroundColor(theme.palette.error.light, theme.palette.mode),
          },
          "& .MuiDataGrid-row.super-app-theme--ERROR--false:hover": {
            bgcolor: (theme) =>
              getHoverBackgroundColor(
                theme.palette.error.light,
                theme.palette.mode
              ),
          },
          "& .MuiDataGrid-row.super-app-theme--ReadytoBill.Mui-selected": {
            backgroundColor: lighten("#1565c0", 0.8),
          },
          "& .MuiDataGrid-row.super-app-theme--ReadytoBill.Mui-selected:hover":
          {
            backgroundColor: lighten("#1565c0", 0.6),
          },
        }}
      >
        <div style={{ height: 'calc(100vh - 225px)', width: '100%' }}>
          <DataGridPro
            initialState={initialSettings.columns ? initialSettings : {
              sorting: {
                sortModel: [{ field: "CreateDate", sort: "desc" }],
              },
              pagination: { paginationModel: { pageSize: 25 } },
              density: "compact"
            }}
            loading={initGridDataLoading}
            columnHeaderHeight={100}
            onRowSelected={(params) => console.log(params)}
            justifyContent="center"
            checkboxSelection={true}
            rowSelectionModel={selectionModel}
            isRowSelectable={(params) => params.row.isSubmittable || (!params.row.isSubmittable && params.row.Status === "Ready to Bill")}
            onRowSelectionModelChange={(model) => {
              setSelectionModel({ ...model });
            }}
            onCellDoubleClick={(params, event) => {
              if (params.field === 'Status' && selectionModel.ids.size > 1) {
                event.defaultMuiPrevented = true;
              }
              if (params.field === 'Status' && !['Ready to Bill', 'Deferred'].includes(params.value)) {
                event.defaultMuiPrevented = true;
              }
              if (params.field === 'placeOfServiceCode' && selectionModel.ids.size > 1) {
                event.defaultMuiPrevented = true;
              }
              if (params.field === 'payerId' && selectionModel.ids.size > 1) {
                event.defaultMuiPrevented = true;
              }
              handleCellDoubleClick(params);
            }}
            density={density}
            onDensityChange={(newDensity) => setDensity(newDensity)}
            rows={rows}
            columns={cols}
            apiRef={apiRef}
            onColumnOrderChange={handleColumnOrderChange}
            columnVisibilityModel={colVisModel}
            onColumnVisibilityModelChange={(newModel) => setColVisModel(newModel)}
            getRowClassName={(params) => {
              if (!params.row.isSubmittable) {
                return `super-app-theme--${String(params.row.Status).replaceAll(
                  " ",
                  ""
                )}--${params.row.isSubmittable}`;
              } else {
                let mods = params.row.procedureModifierCode;
                if (typeof mods !== "string" || mods === "null") {
                  mods = "";
                }
                mods = mods.split(":");
                if (
                  (mods[0] === "" &&
                    mods.length === 1 &&
                    params.row.procedureCode.length === 5) ||
                  (mods[0] !== "" &&
                    mods.filter((m) => m.length === 2).length === mods.length &&
                    params.row.procedureCode.length === 5)
                ) {
                  return `super-app-theme--${params.row.Status}--${params.row.isSubmittable}`;
                } else {
                  return `super-app-theme--CHECKPROCCODE`;
                }
              }
            }}
            slots={{
              color: '#3fadf6',
              toolbar: DefaultToolbar,
              noRowsOverlay: () => (
                <Box sx={{ height: "100%", display: 'flex', alignItems: "center", margin: 'auto', justifyContent: "center" }}>
                  <Typography>No claims yet for this month in the system</Typography>
                </Box>
              ),
            }}
            pagination
            pageSizeOptions={[25, 50, 100]}
            onRowClick={(params) => onSelect(params.id)}
            isCellEditable={(params) => ["Denied", "Rejected", "Pending", "Ready to Bill"].includes(params.row.Status)}
            processRowUpdate={(updatedRow, originalRow) => {
              return handleCellEditCommit(updatedRow, originalRow);
            }}
            slotProps={{
              cell: {
                onBlur: (params) => setEditStatusMode(false),
              },
              toolbar: {
                children: (
                  <>
                    {(Array.isArray(toolbarButtons) ? toolbarButtons : []).map((Btn, idx) => (
                      <Btn key={idx} />
                    ))}
                    <SaveViewButton onClick={debounce(handleSaveSettings, 500)} />
                  </>
                ),
              },
            }}
            toolbarButtons={toolbarButtons}
            showToolbar />
          {!!snackbar && (
            <Snackbar
              open
              anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
              onClose={handleCloseSnackbar}
              autoHideDuration={6000}
            >
              <Alert {...snackbar} onClose={handleCloseSnackbar} />
            </Snackbar>
          )}
        </div>
      </Box>
    );
    return claimsListFin;
  }

  async function processData(payerList, row) {
    let payerDets = payerList.find((p) => p.payerId === +(row.payerId));

    let formVals = row;

    let existingFormValues = {
      claimId: row.claim_ID,
      payerName: payerDets.payerDets.payer_name,
      payerId: payerDets.payerId,
      insuredIdNumber: formVals.memberMedicaid,
      insuredName: formVals.LastName + " " + formVals.FirstName,
      patFirstName: formVals.FirstName,
      patLastName: formVals.LastName,
      patDob: formVals.DateOfBirth,
      patGender: formVals.Gender,
      patAddrLine1: formVals.patientAddrLine1,
      patAddrLine2: "",
      patCity: formVals.patientCity,
      patState: formVals.patientState,
      patZip: formVals.patientZip,
      patCountry: "",
      patRelationship: formVals.patientRel,
      insuredAddrLine1: formVals.patAddrLine1,
      insuredAddrLine2: "",
      insuredCity: formVals.patientCity,
      insuredState: formVals.patientState,
      insuredZip: formVals.patientZip,
      insuredCountry: "",
      maritalStatus: "",
      employmentStatus: "",
      secondaryLastName: "",
      secondaryFirstName: "",
      secondaryPolicy: "",
      secondaryDob: "",
      secondaryGender: "",
      primaryPaymentDate: "",
      secondaryPayerName: "",
      secondaryPayerId: "",
      secondaryPayerClaimId: "",
      medicareTypeCode: "",
      secondaryPatRelationship: "",
      secondaryPayerGroupName: "",
      secondaryPayerGroupNumber: "",
      patConditionEmp: "",
      patConditionAuto: "",
      patConditionAutoState: "",
      patConditionAutoCountry: "",
      patConditionOther: "",
      claimCodes: "",
      insuredPolicyGroup: "",
      insuredDob: formVals.DateOfBirth,
      insuredGender: formVals.Gender,
      employerName: "",
      insurancePlanName: "",
      supervisingProviderFirstName: "",
      supervisingProviderLastName: "",
      supervisingProviderId: "",
      supervisingProviderNPI: "",
      dateOfCondition: "",
      addDate: "",
      referringPhysicianFirstName: "",
      referringPhysicianLastName: "",
      referringNPI: "",
      referringOtherId: "",
      claimNarrative: "",
      hospitalizationDateFrom: "",
      hospitalizationDateTo: "",
      diagA: "",
      diagB: "",
      diagC: "",
      diagD: "",
      diagE: "",
      diagF: "",
      diagG: "",
      diagH: "",
      diagI: "",
      diagJ: "",
      diagK: "",
      diagL: "",
      resubmissionCode: "",
      resubmissionPayerICN: "",
      priorAuthNumber: formVals.priorAuth,
      referralNumber: "",
      cliaNumber: "",
      dateOfServiceFrom: formVals.startDate,
      dateOfServiceTo: formVals.endDate,
      pos: formVals.placeOfServiceCode,
      emg: "",
      procedureCode: "",
      procedureCodeModifier1: "",
      procedureCodeModifier2: "",
      procedureCodeModifier3: "",
      procedureCodeModifier4: "",
      diagRef: "A",
      charges: formVals.authAmount,
      units: formVals.authUnits,
      taxId: companyData.com_taxid,
      taxIdType: "E",
      patientAccountNumber: formVals.DDDID,
      acceptAssign: "Y",
      totalCharge: formVals.authAmount,
      amountPaid: "0",
      balance: formVals.authAmount,
      renderingProviderFirstName: "",
      renderingProviderLastName: "",
      renderingProviderTaxonomy: "",
      renderingProviderNPI: "",
      renderingProviderId: "",
      facilityName: "",
      facilityAddrLine1: "",
      facilityAddrLine2: "",
      facilityCity: "",
      facilityState: "",
      facilityZip: "",
      facilityCountry: "",
      facilityNPI: "",
      facilityId: "",
      billingProvName: "",
      billingProvAddrLine1: "",
      billingProvAddrLine2: "",
      billingProvCity: "",
      billingProvState: "",
      billingProvZip: "",
      billingProvPhone: "",
      billingProvTaxonomy: "",
      billingProvNPI: "",
      billingProvId: ""
    }
    let codes = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L'];
    let diags = formVals.DiagnosisCode.split("/");
    diags.forEach((ele, index) => {
      existingFormValues["diag" + codes[index]] = ele;
    })

    let procCodes = [...formVals.procedureCode.split(":")];
    if (formVals.procedureModifierCode) {
      procCodes.push(...String(formVals.procedureModifierCode).split(":"));
    }
    let procCode = procCodes[0];
    existingFormValues.procedureCode = procCode;
    let procCodeModifiers = procCodes.slice(1);
    procCodeModifiers.forEach((ele, index) => {
      existingFormValues["procedureCodeModifier" + String(index + 1)] = ele;
    });
    formDisplayContent.current = existingFormValues;
  }

  async function handleCMSFormChange(key, value) {
    let updatedContents = { ...formDisplayContent.current, [key]: value };

    formDisplayContent.current = updatedContents;
  }

  function handleFormModalCancel() {
    if (newClaimCMSForm) {
      currClaimsList.current = currClaimsList.current.filter(c => c.claim_ID !== undefined);
      setClaimsList(currClaimsList.current);
      setNewClaimCMSForm(false);
    }
    setShowFormModal(false);
    setFormErrors([]);
    formDisplayContent.current = {};
  }

  async function handleFormModalSave() {
    let keyMap = {
      insuredIdNumber: "memberMedicaid",
      patFirstName: "FirstName",
      patLastName: "LastName",
      patDob: "DateOfBirth",
      patGender: "Gender",
      patAddrLine1: "patientAddrLine1",
      patCity: "patientCity",
      patState: "patientState",
      patZip: "patientZip",
      patRelationship: "patientRel",
      priorAuthNumber: "priorAuth",
      dateOfServiceFrom: "startDate",
      dateOfServiceTo: "endDate",
      concatDiagnosisCode: "DiagnosisCode",
      procedureCode: "procedureCode",
      concatProcedureCodeModifier: "procedureModifierCode",
      charges: "authAmount",
      units: "authUnits",
      patientAccountNumber: "DDDID",
      pos: "placeOfServiceCode",
      payerId: "payerId",
    }

    let fieldToHeader = {
      DDDID: "DDDID",
      FirstName: "Patient First Name",
      LastName: "Patient Last Name",
      DateOfBirth: "Patient DOB",
      Gender: "Gender",
      memberMedicaid: "Medicaid ID",
      patientCity: "Patient City",
      patientState: "Patient State",
      patientZip: "Patient Zip",
      patientAddrLine1: "Patient Address Line 1",
      patientRel: "Patient Relationship",
      placeOfServiceCode: "Place of Service Code",
      priorAuth: "Prior Authorization",
      procedureCode: "Procedure Code",
      procedureModifierCode: "Procedure Code Modifier",
      startDate: "Task Start Date",
      endDate: "Task End Date",
      DiagnosisCode: "Diagnosis Code",
      authUnits: "Authorized Units",
      authAmount: "Authorized Amount",
      payerId: "Payer Id",
    };

    const optionalFields = formDisplayContent.current.payerName === 'NJ Medicaid' ? [
      "patientAddrLine1",
      "patientCity",
      "patientRel",
      "patientState",
      "patientZip",
      "placeOfServiceCode",
      "procedureModifierCode"
    ] : ["patientRel",
      "placeOfServiceCode",
      "procedureModifierCode"];

    let updatedRow = claimsList.find((c) => c.claim_ID === formDisplayContent.current.claimId)
    let currentClaimId = updatedRow?.claim_ID;
    let previousStatus = updatedRow?.Status;
    let updated = false;
    let allErrors = []
    let allErrorKeys = []
    let isNewClaim = currentClaimId === undefined;

    let newDiagCode = Object.entries(formDisplayContent.current).filter(([key, value]) => key.substring(0, 4) === 'diag' && key !== 'diagRef' && value).map(([key, value]) => value.replaceAll(".", "")).join("/");
    formDisplayContent.current["concatDiagnosisCode"] = newDiagCode;

    let newProcCodeModif = Object.entries(formDisplayContent.current).filter(([key, value]) => key.substring(0, 21) === 'procedureCodeModifier' && value).map(([key, value]) => value).join(":");
    formDisplayContent.current["concatProcedureCodeModifier"] = newProcCodeModif;

    // For new claims, prepare data for insertion
    let validDataForInsert = {};
    let hasValidData = false;

    for (let key of Object.keys(formDisplayContent.current)) {
      if (keyMap[key]) {
        let errors = checkClaim(keyMap[key], formDisplayContent.current[key], payerList, formDisplayContent.current.payerName === 'NJ Medicaid');
        let hasChanged = isNewClaim || (updatedRow[keyMap[key]] !== formDisplayContent.current[key]);
        if (hasChanged && Object.values(errors).filter(val => val === true).length == 0) {
          updated = true;
          if (isNewClaim) {
            if (optionalFields.includes(keyMap[key])) {
              if (formDisplayContent.current[key] && formDisplayContent.current[key].trim() !== '') {
                validDataForInsert[keyMap[key]] = formDisplayContent.current[key];
              }
            } else {
              // For required fields: always include if valid
              validDataForInsert[keyMap[key]] = formDisplayContent.current[key];
              hasValidData = true; // Only set true for non-optional fields
            }
          } else {
            // Existing claim update logic
            let updateResult = await updateClaimData([formDisplayContent.current.claimId], keyMap[key], formDisplayContent.current[key]);
            if (updateResult.code >= 400) {
              allErrors.push(`Updating ${fieldToHeader[keyMap[key]]} will create a duplicate claim.`);
            } else {
              updatedRow[keyMap[key]] = formDisplayContent.current[key];
            }
          }
        } else if (Object.values(errors).filter(val => val === true).length != 0) {
          if (keyMap[key] in fieldToHeader) {
            allErrorKeys.push(key);
            if (errors.empty) {
              allErrors.push(`${fieldToHeader[keyMap[key]]} can't be empty.`);
            } else if (errors.notNum) {
              allErrors.push(`${fieldToHeader[keyMap[key]]} has to be a number.`);
            } else if (errors.notDec) {
              allErrors.push(`${fieldToHeader[keyMap[key]]} has to be a decimal.`);
            } else if (errors.invalidDate) {
              allErrors.push(`${fieldToHeader[keyMap[key]]} has to be a valid date(MM/DD/YYYY).`);
            } else if (errors.invalidGender) {
              allErrors.push(`${fieldToHeader[keyMap[key]]} has to be either M or F.`);
            } else if (errors.invalidLength) {
              if (keyMap[key] === "priorAuth") {
                allErrors.push(`${fieldToHeader[keyMap[key]]} has to be of length 10 and has to start from 01 through 15.`);
              }
            } else if (errors.invalidName) {
              allErrors.push(`${fieldToHeader[keyMap[key]]} can only contain letters, commas, periods, hyphens and single quotation marks.`);
            } else if (errors.invalidAlphanum) {
              allErrors.push(`${fieldToHeader[keyMap[key]]} only supports alphanumeric characters, backslashes and colons without spaces.`);
            } else if (errors.invalidDiagnosisCode) {
              allErrors.push(`${fieldToHeader[keyMap[key]]} only supports alphanumeric characters and backslashes without spaces.`);
            } else if (errors.earlyBillDate) {
              allErrors.push(`${fieldToHeader[keyMap[key]]} should be same or before today's date.`);
            } else if (errors.invalidPayerId) {
              allErrors.push(`${fieldToHeader[keyMap[key]]} has not been added to your company, add it to your company from your company settings first.`)
            }
          }
        }
      }
    }

    // Handle new claim insertion
    if (isNewClaim && hasValidData) {
      try {
        validDataForInsert["companyID"] = props.user.comp_id;
        validDataForInsert["uploadedBy"] = props.user.emp_id;
        for (let key of Object.keys(keyMap)) {
          if (!validDataForInsert[keyMap[key]]) {
            validDataForInsert[keyMap[key]] = '';
          }
        }
        // Assuming you have an insertClaimData function similar to updateClaimData
        let insertResult = (await axios.post(APIURL + "/claims", {
          claimInfo: { ...updatedRow, ...validDataForInsert },
        })).data;
        validDataForInsert["claim_ID"] = insertResult.claim_ID;
        console.log(validDataForInsert);

        if (insertResult.claim_ID) {
          // Successfully inserted, update the current claim ID for further processing
          currentClaimId = insertResult.claim_ID;
          formDisplayContent.current.claimId = currentClaimId;

          console.log(currClaimsList.current);
          // Create a new claim object for the list
          currClaimsList.current = currClaimsList.current.map((claim) => {
            if (claim.claim_ID === undefined) {
              return {
                ...claim,
                claim_ID: currentClaimId,
                Status: "Ready to Bill",
                ...validDataForInsert
              };
            }
            return claim;
          });

          setClaimsList(currClaimsList.current);

          updatedRow = currClaimsList.current.find((claim) => claim.claim_ID === currentClaimId);
        } else {
          allErrors.push("Failed to insert new claim. Please try again.");
        }
      } catch (error) {
        console.error("Error inserting new claim:", error);
        allErrors.push("An error occurred while saving the new claim.");
      }
    }

    // Update status for existing claims (keep original logic)
    if (updated && !isNewClaim && (previousStatus === 'Denied' || previousStatus === 'Pending' || previousStatus === 'Rejected')) {
      await updateClaimData(
        [currentClaimId],
        "Status",
        "Ready to Bill"
      );
    }

    if (updated) {
      if (!isNewClaim) {
        // Update existing claim in list (keep original logic)
        currClaimsList.current = currClaimsList.current.map((claim) => {
          if (claim.claim_ID === updatedRow.claim_ID) {
            return { ...updatedRow, "Status": (previousStatus === 'Denied' || previousStatus === 'Pending' || previousStatus === 'Rejected') ? "Ready to Bill" : claim.Status };
          }
          return { ...claim };
        });
        setClaimsList(currClaimsList.current);
      }

      // Run error checker if we have a valid claim ID
      if (currentClaimId) {
        console.log(currClaimsList.current.find((claim) => claim.claim_ID === currentClaimId))
        errorChecker(currClaimsList.current.find((claim) => claim.claim_ID === currentClaimId), currClaimsList.current.find((claim) => claim.claim_ID === currentClaimId).id, payerList);
      }

      if (allErrors.length !== 0) {
        setErrorKeys(allErrorKeys);
        setFormErrors(allErrors);
        if (isNewClaim && hasValidData) {
          setSnackbar({
            children: "New claim created with valid fields! Please fix the errors for the remaining fields!",
            severity: "warning",
          });
        } else {
          setSnackbar({
            children: "All the fields without errors were successfully saved! Please fix the errors to save the remaining fields!",
            severity: "warning",
          });
        }
      } else {
        setShowFormModal(false);
        setFormErrors([]);
        setErrorKeys([]);
        formDisplayContent.current = {};
        if (isNewClaim) {
          setSnackbar({
            children: "New claim successfully created!",
            severity: "success",
          });
        } else {
          setSnackbar({
            children: "All details were successfully saved!",
            severity: "success",
          });
        }
      }
      setClaimsList(currClaimsList.current);
    } else {
      setSnackbar({
        children: "No new changes to save! Please update a field before saving",
        severity: "error",
      });
    }
  }

  return (
    <div>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "flex-start",
          height: "100%",
          width: "100%",
          backgroundColor: "#fafafa"
        }}
      >
        <div
          style={{
            display: "flex",
            flex: "0 0 auto",
            flexDirection: "column",
            justifyContent: "flex-start",
            height: "100%",
            width: "100%"
          }}
        >
          {!isLoading && (
            <div style={{ display: "flex", flexDirection: "row", width: "100%", marginBottom: "10px" }}>
              <div
                style={{ display: "flex", alignItems: "center", width: "100%", marginTop: "5px" }}>
                <Button
                  size="large"
                  variant="contained"
                  onClick={() => onDateChange(currentMonth.subtract(1, "month"))}
                >
                  <i className="fas fa-arrow-left"></i>
                </Button>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    label="Select Month"
                    views={["year", "month"]}
                    value={new Date(currentMonth)}
                    onChange={(newValue) => {
                      onDateChange(newValue);
                    }}
                    slotProps={{ textField: { size: 'small', style: { marginLeft: 20, marginRight: 20 } } }}
                  />
                </LocalizationProvider>
                <Button
                  size="large"
                  variant="contained"
                  onClick={() => onDateChange(currentMonth.add(1, "month"))}
                >
                  <i className="fas fa-arrow-right"></i>
                </Button>
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end", flexDirection: "row", width: "100%" }}>

                <div style={{ marginTop: 15, marginLeft: 10, marginRight: 10, width: "30%" }}>
                  <Box
                    display="flex"
                    justifyContent="flex-end"
                    alignItems="center"
                  >
                    {gridDataLoading && (
                      <CircularProgress size={24} style={{ marginRight: '85px' }} />
                    )}
                    <Button
                      variant="contained"
                      style={{ marginLeft: "-50px" }}
                      onClick={() => {
                        setCsvAdd(!csvAdd);
                      }}
                    >
                      Upload Claims
                    </Button>
                  </Box>
                </div>
                {!selectValidClaims &&
                  selectionModel.ids.size === 0 &&
                  getSelectButton()}
                {(selectValidClaims || selectionModel.ids.size !== 0) &&
                  getUnselectButton()}
                {(selectValidClaims || selectionModel.ids.size !== 0) &&
                  getSendButton()}
              </div>
            </div>
          )}

          {!isLoading && getClaimsList()}
          {!!isLoading && (
            <div style={{ display: "flex", flexDirection: "row", width: "100%", justifyContent: "center", marginTop: "3rem" }}>
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          )}
          {!!isLoadingApiCall && (
            <div style={{ left: 0, top: 0, width: "100%", height: "100%", position: "fixed", backgroundColor: "rgba(16, 16, 16, 0.8)" }}>
              <div style={{ left: 0, top: 0, width: "100%", height: "100%", position: "absolute", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                <div>
                  <span className="spinner"></span>
                </div>
                <div style={{ color: "#3fa7d6" }}>
                  Please wait, your request is being processed!
                </div>
              </div>
            </div>
          )}
          {editNote &&
            <Dialog open={editNote} onClose={() => { setEditNote(false); setEditRow(null); }} maxWidth="md" fullWidth disableEnforceFocus>
              <DialogTitle>{editRow.billingNoteId ? 'Edit Note' : 'Add Note'}</DialogTitle>
              <DialogContent>
                <div>
                  <CssTextField
                    multiline
                    value={noteText}
                    onChange={(event) => {
                      setNoteText(event.target.value);
                    }}
                    style={{ margin: '5px', width: '100%' }}
                    inputProps={{ maxLength: 2000 }}
                    minRows={8}
                    label="Note"
                    variant="outlined"
                    id="bNote"
                  />
                </div>
              </DialogContent>
              <DialogActions>
                <Button variant="contained"
                  style={{
                    width: '100%',
                    padding: '5px',
                    margin: '5px',
                  }}
                  onClick={() => editRow.billingNoteId ? updateBillingNote(editRow.billingNoteId, noteText, editRow.claim_ID) : addBillingNote(editRow.claim_ID, noteText)}
                >
                  {editRow.billingNoteId ? 'Edit Note' : 'Add Note'}
                </Button>
              </DialogActions>
            </Dialog>
          }
          {bulkEditModal &&
            <Dialog open={bulkEditModal} onClose={() => { setBulkEditMode(""); setBulkEditModal(false); }} maxWidth="sm" fullWidth disableEnforceFocus>
              <DialogTitle>{`Bulk edit ${bulkEditMode === 'Status' ? 'status' : bulkEditMode === 'authAmount' ? 'auth amount' : bulkEditMode === 'payerId' ? 'payer Id' : 'place of service'}`}</DialogTitle>
              <DialogContent>
                <div>
                  {bulkEditMode === 'Status' && <Box sx={{ minWidth: 120 }}>
                    <FormControl fullWidth>
                      <InputLabel>Status</InputLabel>
                      <Select
                        value={bulkEdittedVal}
                        label="Status"
                        onChange={(event) => {
                          setBulkEdittedVal(event.target.value);
                        }}
                      >
                        <MenuItem value={"Deferred"}>Deferred</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>}
                  {bulkEditMode === 'authAmount' && <div><p style={{ display: "inline", fontSize: "12px", color: "grey" }}><i>Only decimal values are allowed.</i></p>
                    <CssTextField
                      value={bulkEdittedVal}
                      onChange={(event) => {
                        setBulkEdittedVal(event.target.value);
                      }}
                      style={{ width: '100%', marginTop: "10px" }}
                      inputProps={{ maxLength: 50 }}
                      minRows={8}
                      label='Auth Amount'
                      variant="outlined"
                      id="bNote"
                    /></div>}
                  {bulkEditMode === 'placeOfServiceCode' && <Box sx={{ minWidth: 120 }}>
                    <FormControl fullWidth>
                      <InputLabel>Place of Service Code</InputLabel>
                      <Select
                        value={bulkEdittedVal}
                        label="Place of Service Code"
                        onChange={(event) => {
                          setBulkEdittedVal(event.target.value);
                        }}
                      >
                        <MenuItem value={"23"}>0 - Emergency Room (23)</MenuItem>
                        <MenuItem value={"11"}>1 - Doctor's Office (11)</MenuItem>
                        <MenuItem value={"12"}>2 - Patient's Home (12)</MenuItem>
                        <MenuItem value={"21"}>3 - Inpatient Hospital (21)</MenuItem>
                        <MenuItem value={"14"}>4 - Boarding Home (14)</MenuItem>
                        <MenuItem value={"31"}>5 - Skilled Nursing Home (31)</MenuItem>
                        <MenuItem value={"81"}>6 - Independent Laboratory (81)</MenuItem>
                        <MenuItem value={"22"}>7 - Outpatient Hospital (22)</MenuItem>
                        <MenuItem value={"49"}>8 - Clinic (49)</MenuItem>
                        <MenuItem value={"99"}>9 - Other (99)</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>}
                  {bulkEditMode === 'payerId' && <div><p style={{ display: "inline", fontSize: "12px", color: "grey" }}><i>Only number values are allowed.</i></p>
                    <FormControl fullWidth>
                      <InputLabel>Payer Id</InputLabel>
                      <Select
                        value={bulkEdittedVal}
                        label="Payer Name"
                        onChange={(event) => {
                          setBulkEdittedVal(event.target.value);
                        }}
                      >
                        {payerList.map((dets) => (
                          <MenuItem value={dets.payerId}>{dets.payer_name !== undefined ? dets.payer_name : dets.payerDets.payer_name} ({dets.payerId})</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>}
                </div>
              </DialogContent>
              <DialogActions>
                <Button variant="contained"
                  style={{
                    width: '100%',
                    padding: '5px',
                    margin: '5px',
                  }}
                  onClick={() => bulkUpdateSelected()}
                >
                  {bulkEditMode === 'Status' ? 'Update Status' : bulkEditMode === 'authAmount' ? 'Update Auth Amount' : bulkEditMode === 'payerId' ? 'Update Payer Id' : 'Update place of service'}
                </Button>
              </DialogActions>
            </Dialog>
          }
          {renderCSVModal()}
        </div>
        <Dialog open={showModal} onClose={() => {
          setShowModal(false);
        }} disableEnforceFocus>
          <DialogTitle style={{ width: "100%", textAlign: "center" }}>SUBMIT CLAIMS</DialogTitle>
          <center>
            <DialogContent>
              You have selected {selectionModel.ids.size} claims.
            </DialogContent>
            <DialogContent>
              Are you sure you want to send the selected claims?
            </DialogContent>
          </center>
          {/* <DialogActions> */}
          <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", margin: "1rem" }}>
            <Button
              variant="contained"
              onClick={() => {
                setShowModal(false);
              }}
              style={{
                backgroundColor: "white",
                color: "grey",
              }}
            >
              Back
            </Button>
            <Box style={{ width: "30px" }}></Box>
            <Button
              variant="contained"
              onClick={() => {
                setNextStep(true);
                handleConfirmModal();
              }}
              style={{
                backgroundColor: "green",
              }}
            >
              Yes
            </Button>
          </div>
          {/* </DialogActions> */}
        </Dialog>
        <Dialog open={showDelModal} onClose={handleDelConfirmModal} disableEnforceFocus>
          <DialogTitle style={{ width: "100%", textAlign: "center" }}>DELETE CLAIMS</DialogTitle>
          <center>
            <DialogContent>
              You have selected {selectionModel.ids.size} claims.
            </DialogContent>
            <DialogContent>
              Are you sure you want to delete the selected claims?
            </DialogContent>
          </center>
          {/* <DialogActions> */}
          <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", margin: "1rem" }}>
            <Button
              variant="contained"
              onClick={handleDelConfirmModal}
              style={{
                backgroundColor: "white",
                color: "grey",
              }}
            >
              Back
            </Button>
            <Box style={{ width: "30px" }}></Box>
            <Button
              variant="contained"
              onClick={() => {
                setDelClaim(true);
                handleDelConfirmModal();
              }}
              style={{
                backgroundColor: "green",
              }}
            >
              Yes
            </Button>
          </div>
          {/* </DialogActions> */}
        </Dialog>
      </div>
      <Dialog open={showFormModal} onClose={handleFormModal} maxWidth="xl" fullWidth disableEnforceFocus>
        <DialogTitle>
          <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%' }}>
              <div>
                {newClaimCMSForm && showFormModal ? 'New claim ' : ''}CMS Form {!newClaimCMSForm && showFormModal ? `for ${claimsList.find((c) => c.claim_ID === formDisplayContent.current.claimId).FirstName}` : ''}
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                <Button variant="outlined" sx={{ marginRight: 1 }} onClick={handleFormModalCancel}>
                  Cancel
                </Button>
                <Button variant="contained" onClick={handleFormModalSave}>
                  Save
                </Button>
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: '#ffb5bb', marginTop: 10, maxHeight: 150, overflow: 'auto' }}>
              {formErrors.map((val) => <Typography sx={{ margin: 1, fontSize: 15 }}>• {val}</Typography>)}
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <CMSForm
            payers={payerList}
            formVals={formDisplayContent.current}
            handleCMSFormChange={handleCMSFormChange}
            disableAll={claimsList.find((c) => c.claim_ID === formDisplayContent.current.claimId) ? ["Released", "Accepted"].includes(claimsList.find((c) => c.claim_ID === formDisplayContent.current.claimId).Status) : false}
            validationErrors={formErrors.length !== 0 ? errorKeys : []}
          />
        </DialogContent>
        {/* </DialogActions> */}
      </Dialog>
    </div>
  );
}